(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["xhCountdown"] = factory();
	else
		root["xhCountdown"] = factory();
})(self, function() {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 541:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => /* binding */ src
});

;// CONCATENATED MODULE: ../../node-v8.11.2-win-x64/node_global/node_modules/vu2b/node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node-v8.11.2-win-x64/node_global/node_modules/vu2b/node_modules/_vue-loader@15.9.3@vue-loader/lib/index.js??vue-loader-options!./src/components/count-down.vue?vue&type=template&id=494d44b0&scoped=true&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "count-down" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "box" }, [
          _c("div", { staticClass: "percent" }, [
            _c("svg", { style: _vm.svgStyle }, [
              _c("circle", _vm._b({}, "circle", _vm.outerAttrs, false)),
              _vm._v(" "),
              _c("circle", _vm._b({}, "circle", _vm.innerAttrs, false))
            ]),
            _vm._v(" "),
            _vm.theSchond > 0
              ? _c("div", { staticClass: "percent-text" }, [
                  _vm._v(_vm._s(_vm.theSchond))
                ])
              : _vm._e()
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true


;// CONCATENATED MODULE: ./src/components/count-down.vue?vue&type=template&id=494d44b0&scoped=true&

;// CONCATENATED MODULE: ./src/components/animation-mixin.js
const rm2 = () => {
  let re;
  const p = new Promise(resolve => {
    re = resolve;
  });
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      re();
    });
  });
  return p;
};
/**
 * 接收到新的数据 ->
 */


/* harmony default export */ const animation_mixin = ({
  methods: {
    async run() {
      if (this.second > 0) {
        await rm2();
        this.timer = setTimeout(() => {
          this.theSchond--;
          this.$emit("change", this.theSchond);
          this.run();
        }, 1000);
      } else {
        this.$emit("end");
      }
    }

  },

  beforeDestroy() {
    this.timer && clearTimeout(this.timer);
  },

  watch: {
    second: {
      handler(newVal, oldVal) {
        if (newVal > 0) {
          if (this.firstRun) {
            this.theSchond = newVal;
            this.firstRun = false;
            return this.run();
          }

          if (newVal === oldVal - 1) {
            return;
          }

          if (newVal > oldVal) {
            this.theSchond += newVal - oldVal;
          }
        }
      },

      immediate: true
    }
  }
});
;// CONCATENATED MODULE: ../../node-v8.11.2-win-x64/node_global/node_modules/vu2b/node_modules/_babel-loader@8.1.0@babel-loader/lib/index.js!../../node-v8.11.2-win-x64/node_global/node_modules/vu2b/node_modules/_vue-loader@15.9.3@vue-loader/lib/index.js??vue-loader-options!./src/components/count-down.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * svg 属性
 * stroke-dasharray :
 *  用于创建虚线 后面其实是跟一个数组，参数为长度、间距，然后重复
 *  那么对于一个圆来讲，需要设置 多少的 stroke-dasharray 才能完全填充吗
 *  理论上应该是周长的两倍
 *  周长公式 : 2 * pi r
 *  例如 : 70 的半径，周长为 439，当设置 stroke-dasharray 为 440 时，是完全覆盖的
 *
 *
 * stroke-dashoffset :
 *  这个属性是相对于起始点的偏移，正数偏移x值的时候，相当于往左移动了x个长度单位，负数偏移x的时候，相当于往右移动了x个长度单位
 *
 * 原理 :
 * - 当 stroke-dasharray 设置为周长两倍时，可看做一根线填充了圆形
 * - 而这根线超出过了周长，只有两段，一根为实线、一根为虚线
 * - 当 stroke-dashoffset 设置为 0 时，刚好为实线覆盖圆
 * - 而当 stroke-dashoffset 为 stroke-dasharray ,则刚好是虚线覆盖圆
 * - 通过 设置 stroke-dashoffset 可以达到百分比的效果，公式为 calc(2倍周长 - (2倍周长 * 占比) / 100)
 */

/* harmony default export */ const count_downvue_type_script_lang_js_ = ({
  mixins: [animation_mixin],
  props: {
    second: {
      type: Number,
      default: 30
    },
    radius: {
      type: Number,
      default: 70
    }
  },

  data() {
    return {
      theSchond: 0,
      firstRun: true,
      timer: null
    };
  },

  computed: {
    // 周长 
    perimeter() {
      return Math.PI * 2 * this.radius;
    },

    // 内接圆属性
    innerAttrs() {
      return {
        cx: this.radius,
        cy: this.radius,
        r: this.radius,
        style: {
          "stroke-dasharray": this.perimeter,
          "stroke-dashoffset": this.perimeter - this.perimeter * this.theSchond / this.second
        }
      };
    },

    // 外接圆属性
    outerAttrs() {
      return {
        cx: this.radius,
        cy: this.radius,
        r: this.radius
      };
    },

    svgStyle() {
      return {
        width: this.radius * 2 + 10,
        height: this.radius * 2 + 10
      };
    }

  }
});
;// CONCATENATED MODULE: ./src/components/count-down.vue?vue&type=script&lang=js&
 /* harmony default export */ const components_count_downvue_type_script_lang_js_ = (count_downvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../../node-v8.11.2-win-x64/node_global/node_modules/vu2b/node_modules/_mini-css-extract-plugin@0.9.0@mini-css-extract-plugin/dist/loader.js!../../node-v8.11.2-win-x64/node_global/node_modules/vu2b/node_modules/_css-loader@4.1.0@css-loader/dist/cjs.js!../../node-v8.11.2-win-x64/node_global/node_modules/vu2b/node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/stylePostLoader.js!../../node-v8.11.2-win-x64/node_global/node_modules/vu2b/node_modules/_postcss-loader@3.0.0@postcss-loader/src/index.js??clonedRuleSet-18[0].rules[0].use[2]!../../node-v8.11.2-win-x64/node_global/node_modules/vu2b/node_modules/_sass-loader@9.0.2@sass-loader/dist/cjs.js!../../node-v8.11.2-win-x64/node_global/node_modules/vu2b/node_modules/_vue-loader@15.9.3@vue-loader/lib/index.js??vue-loader-options!./src/components/count-down.vue?vue&type=style&index=0&id=494d44b0&lang=scss&scoped=true&
var count_downvue_type_style_index_0_id_494d44b0_lang_scss_scoped_true_ = __webpack_require__(772);
;// CONCATENATED MODULE: ./src/components/count-down.vue?vue&type=style&index=0&id=494d44b0&lang=scss&scoped=true&
 /* harmony default export */ const components_count_downvue_type_style_index_0_id_494d44b0_lang_scss_scoped_true_ = ((/* unused pure expression or super */ null && (mod))); 
;// CONCATENATED MODULE: ../../node-v8.11.2-win-x64/node_global/node_modules/vu2b/node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/components/count-down.vue



;


/* normalize component */

var component = normalizeComponent(
  components_count_downvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "494d44b0",
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/components/count-down.vue"
/* harmony default export */ const count_down = (component.exports);
;// CONCATENATED MODULE: ./src/index.js

/* harmony default export */ const src = (count_down);

/***/ }),

/***/ 772:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop)
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// module exports must be returned from runtime so entry inlining is disabled
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(541);
/******/ })()
;
});